import { ReactNode } from 'react';

type ModalProps = {
  isOpen: boolean;
  children: ReactNode;
  className?: string;
  innerClassName?: string;
};

export function Modal({
  isOpen,
  children,
  className,
  innerClassName,
}: ModalProps) {
  return (
    <div>
      {isOpen && (
        <div
          className={`fixed inset-0 bg-black bg-opacity-70 z-40 flex items-center justify-center ${className}`}
        >
          <div
            className={`bg-white px-3 py-3 rounded-lg shadow-lg z-50 ${innerClassName}`}
          >
            {children}
          </div>
        </div>
      )}
    </div>
  );
}
